var x, i, j, l, ll, selElmnt, a, b, c;
/* Look for any elements with the class "custom-select": */
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName("select")[0];
    ll = selElmnt.length;
    /* For each element, create a new DIV that will act as the selected item: */
    a = document.createElement("DIV");
    a.setAttribute("class", "select-selected");
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement("DIV");
    b.setAttribute("class", "select-items select-hide");
    for (j = 1; j < ll; j++) {
        /* For each option in the original select element,
        create a new DIV that will act as an option item: */
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function (e) {
            /* When an item is clicked, update the original select box,
            and the selected item: */
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
                if (s.options[i].innerHTML == this.innerHTML) {
                    s.selectedIndex = i;
                    h.innerHTML = this.innerHTML;
                    y = this.parentNode.getElementsByClassName("same-as-selected");
                    yl = y.length;
                    for (k = 0; k < yl; k++) {
                        y[k].removeAttribute("class");
                    }
                    this.setAttribute("class", "same-as-selected");
                    break;
                }
            }
            h.click();
        });
        b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener("click", function (e) {
        /* When the select box is clicked, close any other select boxes,
        and open/close the current select box: */
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle("select-hide");
        this.classList.toggle("select-arrow-active");
    });
}

function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i);
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

/* If the user clicks anywhere outside the select box,
then close all select boxes: */
document.addEventListener("click", closeAllSelect);



$('document').ready(function () {
    $(".input_file").change(function () {
        if (this.files && this.files[0]) {
            let reader = new FileReader();
            reader.onload = function (e) {
                $('#output').attr('src', e.target.result);
                console.log($('#output').attr('src', e.target.result))
            };
            reader.readAsDataURL(this.files[0]);
        }
    });
    let reset = $('#reset');
    $('#icon').click(function (e){
        $(reset).html(`<img id="output" src="/img/profile/img_empty.png">`);
        $(".input_file").val(null);
    })
});


if (document.querySelector(".row")) {
    const fields = document.querySelectorAll(".text-center");

    function handleInputFile( {target} ) {
        const value = target.value.slice(0, 1);
        target.value = value;

        console.log(target.value);

        const step = value ? 1 : -1;
        const fieldIndex = [...fields].findIndex((field) => field === target);
        const focusToIndex = fieldIndex + step;

        if (focusToIndex < 0 || focusToIndex >= fields.length) return;
        fields[focusToIndex].focus();
    }

    fields.forEach((field) => {
        field.addEventListener("input", handleInputFile);
    });
}

let table_data = $('.table_body .table_body_row > div');
$(table_data).addClass('table-data');
let over_5 = $('.table_body.over_5>.table_body_row>div:nth-child(5)').addClass('over_5');
let over_3 = $('.table_body.over_3>.table_body_row>div:nth-child(3)').addClass('over_3');
let properties = [
    'name',
    'wins',
    'draws',
    'losses',
    'total',
    'costs',
];

$.each(properties, function (i, val) {

    let orderClass = '';

    $("#" + val).click(function (e) {
        e.preventDefault();
        $(this).toggleClass('filter__link--active');

        let parent = $(this).closest('.header__item');
        let index = $(".header__item").index(parent);
        let $table = $('.table_body');
        let rows = $table.find('.table_body_row').get();
        let isSelected = $(this).hasClass('filter__link--active');
        let isNumber = $(this).hasClass('filter__link--number');

        rows.sort(function (a, b) {

            var x = $(a).find('.table-data').eq(index).text();
            var y = $(b).find('.table-data').eq(index).text();

            if (isNumber == false) {

                if (isSelected) {
                    return x - y;
                } else {
                    return y - x;
                }

            } else {

                if (isSelected) {
                    if (x < y) return -1;
                    if (x > y) return 1;
                    return 0;
                } else {
                    if (x > y) return -1;
                    if (x < y) return 1;
                    return 0;
                }
            }
        });

        $.each(rows, function (index, row) {
            $table.append(row);
        });

        return false;
    });

});
      let inp = $('.datepicker-here');
      inp.datepicker([]);
      let content = $('.datepicker--content .datepicker--days')
      let cal_close = $('.datepicker')

      $(content).append(
          `<div class="color_border br6 depth0 btn_p pointer text-center cal_close mt-3">
                    <p class="ButtonText color_text">Отменить</p>
            </div>`
      );

      $('.cal_close').click(function (){
           $(inp).blur();
           $(cal_close).removeClass('active');
      })

      $('.reset').click(function (){
          $(inp).val(null)
      });


      let link_end = $('.link .table_body_row .table-data:last-child');
      $(link_end).removeClass('table-data');
      let link = $('.link .table_body_row > .table-data');
      link.click(function (){
          window.location="/pages/supplier/debts/finance_review.html";
      });





        let item = $('.send_user_body .table_body_row');
        let user = $('#get_user');
        let textarea = $('#textarea');

        $.each(item, function (index, item) {
            $(item).click(function (e) {
                if (e.target.nodeName === "P" && e.target.className === "ButtonText color_contrast_text_second") {
                    $(user).html(`
                    <div class="user_img">
                       ${e.currentTarget.children[0].children[0].childNodes[1].innerHTML}
                    </div>
                    <p class="header4 color_text ms-2">${e.currentTarget.children[0].innerText}</p>
                    `);
                    $(textarea).html(`
                     <textarea class="form-control" placeholder="Введите информацию, которая может понадобиться поставщику для принятия решения"></textarea>
                    `);
                }
            });
        });

